import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Form, FormGroup, Input } from "reactstrap";
import { z } from "zod";
import { Btn, H3, P } from "../../../AbstractElements";
import {
  CreateAccount,
  DoNotAccount,
  LoginRoute,
} from "../../../utils/Constant";

// Validation schema for new password and confirm password
const passwordValidationSchema = z
  .object({
    newPassword: z
      .string()
      .min(8, "Password must be at least 8 characters long")
      .nonempty("New password is required"),
    confirmPassword: z.string().nonempty("Confirm password is required"),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: "Passwords do not match",
    path: ["confirmPassword"],
  });

interface FormData {
  newPassword: string;
  confirmPassword: string;
}

type Props = {
  email: string;
  setStep: React.Dispatch<React.SetStateAction<number>>;
};

export function ResetPasswordForm({ email, setStep }: Props) {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({
    resolver: zodResolver(passwordValidationSchema),
  });

  const onSubmit = async (data: FormData) => {
    try {
      console.log("New Password:", data.newPassword);
      // Perform the password reset action here

      setStep(4); // Move to next step if needed
      toast.success("Password has been reset successfully.");
    } catch (err) {
      if (err instanceof Error) toast.error(err.message);
      else toast.error("Password reset failed. Please try again.");
    }
  };

  return (
    <Form className="theme-form" onSubmit={handleSubmit(onSubmit)}>
      <H3>{"Reset Password"}</H3>
      <P>{"Please enter your new password"}</P>

      <FormGroup>
        <Input
          type="password"
          placeholder="Enter new password"
          {...register("newPassword")}
        />
        {errors.newPassword && (
          <p className="text-danger">{errors.newPassword.message}</p>
        )}
      </FormGroup>

      <FormGroup>
        <Input
          type="password"
          placeholder="Confirm new password"
          {...register("confirmPassword")}
        />
        {errors.confirmPassword && (
          <p className="text-danger">{errors.confirmPassword.message}</p>
        )}
      </FormGroup>

      <FormGroup className="mb-0 form-sub-title">
        <Link to={`/${LoginRoute}`}>
          {"Do you remember the password? Sign In"}
        </Link>
        <div className="text-end mt-3">
          <Btn color="primary" type="submit" block className="w-100">
            Reset Password
          </Btn>
        </div>
      </FormGroup>
      <P className="mt-4 mb-0 text-center">
        {DoNotAccount}
        <Link className="ms-2" to="/authentication/register_simple">
          {CreateAccount}
        </Link>
      </P>
    </Form>
  );
}
